import React from 'react';
import ReactDOM from 'react-dom/client';
// import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './fonts/outrun_future.otf';
import './fonts/outrun_future_bold.otf';
import './fonts/outrun_future_bold_italic.otf';

ReactDOM.createRoot(
  document.getElementById("root"),
)
  .render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();